import dynamic from "next/dynamic";
const BookAMeetingEmbeddedComponent = dynamic(()=>import("./book-a-meeting-embedded-component"));
import BookAMeetingEmbeddedConfig from "./book-a-meeting-embedded-config";
import BookAMeetingEmbeddedAdvancedConfig from "./book-a-meeting-embedded-advanced-config";
export default {
    BookAMeetingEmbeddedComponent,
    BookAMeetingEmbeddedConfig,
    BookAMeetingEmbeddedAdvancedConfig
};
